import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import {
  DateUtil,
  ScheduledHeroEventStudentListItemDto,
  ScheduledHeroEventUpdateDto,
  ScheduledHeroEventStudentStatusEnum,
  StudentScheduledHeroEventCreateDto
} from '@whetstoneeducation/hero-common';
import { AppEventService } from '../../events.service';

enum ScheduledHeroEventStudentTableColumnsEnum {
  STUDENT_ID = 'Student ID',
  STUDENT_NAME = 'Student Name',
  CHECK_IN_TIMES = 'Check-In Times',
  CHECK_OUT_TIMES = 'Check-Out Times',
  STUDENT_STATUS = 'Student Status',
  ACTION = 'Action'
}

@Component({
  selector: 'app-scheduled-hero-event-view-student-table',
  templateUrl: './scheduled-hero-event-view-student-table.component.html',
  styleUrls: ['./scheduled-hero-event-view-student-table.component.scss']
})
export class ScheduledHeroEventViewStudentTableComponent extends BaseTableComponent<ScheduledHeroEventStudentListItemDto> {
  constructor(public eventsService: AppEventService) {
    super();
  }

  @Input() started: boolean;
  @Input() scheduledHeroEventId: number;
  @Input() allowMultipleEntries: boolean;
  @Output() updated = new EventEmitter<ScheduledHeroEventStudentListItemDto>();

  public columns = ScheduledHeroEventStudentTableColumnsEnum;
  public get displayedColumns() {
    return Object.values(ScheduledHeroEventStudentTableColumnsEnum);
  }

  public studentStatus(student: ScheduledHeroEventStudentListItemDto) {
    return this.eventsService.getStatusForStudent(student);
  }

  getButtonLabel(
    scheduledHeroEventStudentListItemDto: ScheduledHeroEventStudentListItemDto
  ): string {
    const status = this.studentStatus(
      scheduledHeroEventStudentListItemDto
    );
    switch (status) {
      case ScheduledHeroEventStudentStatusEnum.NOT_AT_EVENT:
        return 'Check In';
      case ScheduledHeroEventStudentStatusEnum.AT_EVENT:
        return 'Check Out';
      case ScheduledHeroEventStudentStatusEnum.LEFT_EVENT:
        return 'Check In';
    }
  }

  shouldDisableCheckInOut(
    student: ScheduledHeroEventStudentListItemDto
  ): boolean {
    if (!student.checkInTimes) return false;
    // A student should be prevented from checking in or out if:
    // - They have already checked in and checked out (event is completed), AND
    // - Multiple entries are not allowed
    return (
      student.checkInTimes.length > 0 &&
      student.checkOutTimes.length > 0 &&
      !this.allowMultipleEntries
    );
  }

  async handleButtonAction(
    scheduledHeroEventStudentListItem: ScheduledHeroEventStudentListItemDto
  ) {
    this.isLoading = true;
    this.updated.emit(scheduledHeroEventStudentListItem);
    this.isLoading = false;
  }

  protected readonly DateUtil = DateUtil;
}
